import { explodeKnownProjects } from '@util/project-util'

import type { Project } from '../../aansluiting/project/types/Project'
import { apiClient } from '../../gateways/api'

export { fetchLinkedProjects }

const fetchLinkedProjects = async ({
  linkedProjectIds = [],
}: {
  linkedProjectIds: string[]
}): Promise<Partial<Project>[]> => {
  const { data: aansluitingLinkedProjects } = await apiClient({
    url: `/rest/project/aansluiting/search`,
    method: 'POST',
    data: {
      filters: [
        { name: 'aanvraagID', value: linkedProjectIds, operator: 'in' },
      ],
    },
  })

  const { data: hoofdleidingLinkedProjects } = await apiClient({
    url: `/rest/project/hoofdleiding/search`,
    method: 'POST',
    data: {
      filters: [
        { name: 'aanvraagID', value: linkedProjectIds, operator: 'in' },
      ],
    },
  })

  return explodeKnownProjects(linkedProjectIds, [
    ...hoofdleidingLinkedProjects.items,
    ...aansluitingLinkedProjects.items,
  ])
}
